<template>
  <div>
    <pc-detail :article="article" v-if="!isMobile"/>
    <mobile-detail :article="article" v-else/>
  </div>
</template>

<script>
import PcDetail from '@/pages/d/_id.vue';
import MobileDetail from '@/pages/d/m/_id.vue';
export default {
    layout(context) {
        return context.isMobile ? 'mobile' : 'default';
    },
    components: {
        PcDetail,
        MobileDetail
    },
    async asyncData({ isMobile, params, app }) {
        const { id } = params;
        const articleRes = await app.$service.learning.getArticle(id);
        let article = {};
        if (articleRes !== null) {
            article = articleRes.data;
        }
        return { id, isMobile, article: article || {} };
    },
    data() {
        return {
            id: null,
            isMobile: false,
            article: {}
        };
    }
};
</script>

<style lang="less" scoped>

</style>
